import { deleteTasks as _deleteTasks } from '@griply/services';
import { ID } from '@griply/types';
import {
  collection,
  deleteDoc,
  doc,
  Firestore,
  writeBatch,
} from 'firebase/firestore';
import {
  FirestoreWriteOp,
  logFirestoreWriteError,
} from 'shared/services/error-tracking';

import { getAuthentication, getDatabase } from './helpers';

export const deleteTasks = async (taskIds: ID[]): Promise<void> => {
  const user = (await getAuthentication()).currentUser;

  if (!user) {
    throw Error('unauthenticated');
  }

  const uid = user.uid;

  await _deleteTasks({
    taskIds,
    collection,
    doc,
    deleteDoc,
    db: getDatabase(),
    writeBatch: (_db) => writeBatch(_db as Firestore),
    onWriteError: (error) =>
      logFirestoreWriteError({
        op: FirestoreWriteOp.DeleteTasks,
        error,
        uid,
      }),
  });
};
